import { useParams, Link } from 'react-router-dom';
import './../../pagescss/SubjectTopics.css';
import Number from './../topics/QuizNumber';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import { useState } from 'react';
import { useEffect } from 'react';
import PaidItems from '../AllData/PaidItems';


function QuizNumber() {
    const { type, subject, topic, subjectName } = useParams();
    const [submissions, setSubmissions] = useState([]);
    const filterByPhoneAllQuizSubmissions = submissions;

    const isPayment = localStorage.getItem('userPayment');

    const paidItems = PaidItems;
    const isPaid = paidItems.includes(type);

    const demoTopics = ["CP01", "CC01", "CB01", "atoz"];
    const demoQuizno = [0];
    const isDemo = (topic, quizNo) => {
        return demoQuizno.includes(quizNo) && demoTopics.includes(topic);
    }


    useEffect(() => {
        const saved = localStorage.getItem('quizSubmissions');
        const data = saved ? JSON.parse(saved) : [];
        setSubmissions(data);
    }, []);



    let quizLimit;
    if (subject !== "atoz" && topic !== "atoz") {
        quizLimit = 10;
    } else if (subject !== "atoz" && topic === "atoz") {
        quizLimit = 100;
    } else {
        quizLimit = 200;
    }

    //  if (loading) {
    //      return <Loading message='Loading......' />;
    // }

    return (
        <div className="subject-topics-page">


            {subject === "atoz" ? (
                <><TopNavbar name="Full mock test all subject" /></>
            ) : (
                topic === "atoz" ? (
                    <><TopNavbar name={"Full mock test for " + subject} /></>
                ) : (
                    <><TopNavbar name={"Full mock test for " + subjectName} /></>
                )
            )}

            {subject === "atoz" ? (
                <><TopHeader name="Full mock test all subject" /></>
            ) : (
                topic === "atoz" ? (
                    <><TopHeader name={"Full mock test for " + subject} /></>
                ) : (
                    <><TopHeader name={"Full mock test for " + subjectName} /></>
                )
            )}

            <div className="topics-container">
                {Number.slice(0, quizLimit).map((quizNum, index) => {
                    const quizId = `${type}${subject}${topic}${quizNum.quizNo}`;
                    const userSubmission = filterByPhoneAllQuizSubmissions?.find(
                        submission => submission.quizId === quizId
                    );
                    const isUserQuiz = !!userSubmission;

                    // Safely extract data with fallbacks
                    const score = isUserQuiz ? (userSubmission?.score || 0) : null;
                    const totalQuestions = isUserQuiz ? (userSubmission?.totalQuestions || 0) : null;
                    const percentage = isUserQuiz && totalQuestions > 0
                        ? Math.round((score * 100) / (totalQuestions * 4))
                        : 0;

                    return (
                        <div key={quizNum.id || quizNum.quizNo}>





                            {isPayment || !isPaid || isDemo(topic, quizNum.quizNo) ? (<>

                                {isUserQuiz ? (
                                    <Link
                                        to={`/quiz-details/${quizId}/${type}/${subject}/${topic}/${quizNum.quizNo}/${subjectName}`}
                                        className="link"
                                    >
                                        <div className="topic-card-mocktest-complete">

                                            <div className="topic-header quiz-score">
                                                <p style={{ color: "#c875ff", fontSize: "14px" }}>📋{index+1}: {subjectName.length > 40 ? `${subjectName.substring(0, 38)}...` : subjectName} </p>
                                            </div>
                                            <hr style={{ margin: "3px", }} className="hrline"></hr>
                                            <div className="quiz-score">
                                                <div className="quiz-score">
                                                    <p>Score: {score} out of {totalQuestions * 4} </p>
                                                    <p style={{ color: "orange" }}>{percentage}%</p>
                                                </div>
                                                <p style={{ color: "green" }}>Attempted</p>
                                            </div>
                                        </div>
                                    </Link>
                                ) : (
                                    <Link   to={`/number-of-questions/${type}/${subject}/${topic}/${quizNum.quizNo}/${subjectName}`}  className="link" >

                                        <div className="topic-card">
                                            <div className="topic-header">
                                                <p style={{ color: "#c875ff", fontSize: "14px" }}> 📋 {index+1}: {subjectName.length > 40 ? `${subjectName.substring(0, 38)}...` : subjectName}</p>
                                                <p> {quizNum.quizNo === 0 ? (<><p style={{ color: "orange" }} className='demo-highlight-text'>View Demo</p></>) : (<></>)}</p>
                                            </div>
                                            <hr style={{ margin: "3px", }} className="hrline"></hr>
                                            <div className="quiz-score">
                                                <p></p>
                                                <p style={{ color: "orange", fontSize: "10px" }}>Unattempted</p>
                                            </div>
                                        </div>
                                    </Link>
                                )}

                            </>) : (<>

                                {isUserQuiz ? (
                                    <Link
                                        to="/premium-paywall"
                                        className="link"
                                    >
                                        <div className="topic-card-mocktest-complete">

                                            <div className="topic-header quiz-score">
                                                <p style={{ color: "#c875ff", fontSize: "14px" }}>📋{index+1}: {subjectName.length > 40 ? `${subjectName.substring(0, 38)}...` : subjectName} </p>
                                                <p> {quizNum.quizNo === 0 ? (<><p style={{ color: "orange" }} className='demo-highlight-text'>View Demo</p></>) : (<>🔒</>)}</p>
                                            </div>
                                            <hr style={{ margin: "3px", }} className="hrline"></hr>
                                            <div className="quiz-score">
                                                <div className="quiz-score">
                                                    <p>Score: {score} out of {totalQuestions * 4} </p>
                                                    <p style={{ color: "orange" }}>{percentage}%</p>
                                                </div>
                                                <p style={{ color: "green" }}>Attempted</p>
                                            </div>
                                        </div>
                                    </Link>
                                ) : (
                                    <Link
                                        to="/premium-paywall"
                                        className="link"
                                    >
                                        <div className="topic-card">
                                            <div className="topic-header quiz-score">
                                                <p style={{ color: "#c875ff", fontSize: "14px" }}>📋{index+1}: {subjectName.length > 40 ? `${subjectName.substring(0, 38)}...` : subjectName}</p>
                                                <p>🔒</p>
                                            </div>
                                            <hr style={{ margin: "3px", }} className="hrline"></hr>
                                            <div className="quiz-score">
                                                <p></p>
                                                <p style={{ color: "orange", fontSize: "10px" }}>Unattempted</p>
                                            </div>
                                        </div>
                                    </Link>
                                )}

                            </>)}


                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default QuizNumber;